export default __webpack_public_path__ + "static/media/rowers3.fcdab0e7.jpg";